import styled from 'styled-components';

interface SegmentationCanvasContainerProps {
  scale?: number;
}

export const SegmentationCanvasContainer = styled.div.attrs({
  className: 'SegmentationCanvasContainer',
  id: 'FramesWrapper',
})<SegmentationCanvasContainerProps>(
  ({ scale }) => `
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // width: 100%;
    // height: 100%;
    cursor: pointer;
    transform: scale(${scale});
    // transition: transform 0.2s ease-in-out;
  `
);

export const DrawSection = styled.canvas.attrs({
  className: 'DrawSection',
  id: 'Draw',
})`
  width: 100% !important;
  height: 100% !important;
`;

export const WrapDrawControl = styled.div.attrs({
  className: 'WrapDrawControl',
})``;

export const ButtonsContainer = styled.div.attrs({
  className: 'ButtonsContainer',
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 10px;
  top: 10px;
  z-index: 999;
`;

interface ButtonProps {
  disabled?: boolean;
  active?: boolean;
}

export const Button = styled.div.attrs({
  className: 'Button',
})<ButtonProps>(
  ({ disabled, active }) => `
    padding: 10px;
    background: ${disabled ? 'none' : active ? '#3498db' : '#222'};
    color: ${disabled ? '#999' : '#ccc'};
    border-radius: 5px;
    height: 32px;
    width: 100px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    cursor: ${disabled ? 'default' : 'pointer'};
    margin-bottom: 5px;
    &:hover {
      background: ${disabled ? 'none' : active ? '#3094d7' : '#1d1d1d'};
    }
  `
);
